import React from "react";

const VideoControls = ({
  onPrevFrame,
  onNextFrame,
  onPlayPause,
  isPlaying,
  playbackRates,
  currentPlaybackRate,
  onPlaybackRateChange,
  switchViewMode,
  approveVideo,
  rejectVideo,
  isActionSubmitting = false,
}) => {
  return (
    <div className="flex items-center bg-gray-700 p-2 gap-2">
      {/* Switch view mode button */}
      <button onClick={switchViewMode} className="px-2 py-1 bg-gray-600 text-white rounded mx-3" disabled={isPlaying}>Switch view</button>
      <button onClick={onPrevFrame} className="px-2 py-1 bg-gray-600 text-white rounded">Prev</button>
      <button onClick={onPlayPause} className="px-2 py-1 bg-gray-600 text-white rounded mx-2">
        {isPlaying ? 'Pause' : 'Play'}
      </button>
      <button onClick={onNextFrame} className="px-2 py-1 bg-gray-600 text-white rounded">Next</button>
      <select
        value={currentPlaybackRate}
        onChange={(e) => onPlaybackRateChange(parseFloat(e.target.value))}
        className="ml-4 bg-gray-600 text-white rounded"
      >
        {playbackRates.map(rate => (
          <option key={rate} value={rate}>x{rate}</option>
        ))}
      </select>

      <div className="ml-auto flex items-center gap-2">
        <button
          onClick={approveVideo}
          type="button"
          disabled={isActionSubmitting}
          className="text-white py-1 px-3 rounded-md bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isActionSubmitting ? 'Submitting...' : 'Approve'}
        </button>
        <button
          onClick={rejectVideo}
          type="button"
          disabled={isActionSubmitting}
          className="text-white py-1 px-3 rounded-md bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isActionSubmitting ? 'Submitting...' : 'Reject'}
        </button>
      </div>
    </div>
  );
};

export default VideoControls;
